import { Injectable } from '@angular/core';
import { SignupService } from './signup.service';
import { UserInformationService } from './userInformation.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { Router } from '@angular/router';
import { ProfileService } from './profile.service';
import { MessageemitterService } from './messageemitter.service';
import { LocalstorageService } from './localstorage.service';
import { LoginService } from './login.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CompleteSignUpService {

  companyDetails: any;
  companySummaryInformation: any = [];
  baseUrlAxlePoint: string = environment.baseUrlForAxlePoint;
  rootURL: string = environment.baseUrl;
  customResponse: any;
  pageLoader = new BehaviorSubject<boolean>(false);

  constructor(
    private signupService: SignupService,
    private userInformationService: UserInformationService,
    private router: Router,
    private http: HttpClient,
    private profileService: ProfileService,
    private loginService: LoginService,
    private localStorageService: LocalstorageService,
  ) { }

  completeSignUp() {
    this.companyDetails = this.signupService.getCompanyDetails();
    const inviteDataReq = this.signupService.getInvitedCustomer(this.companyDetails.email);
    const userInfoReq = this.userInformationService.getUserInformationByEmail(this.companyDetails.email);
    forkJoin([userInfoReq, inviteDataReq]).subscribe((res: any) => {
      this.pageLoader.next(true);
      this.companySummaryInformation = res[0];
      sessionStorage.setItem('userName', res[0].email);
      this.updateLegecyKey();
    }, (err) => {
      console.error('CompleteSignUpService_completeSignUp', err);
    });
  }

  updateLegecyKey() {
    const headers = new HttpHeaders({
      token: 'TTNFleet2018',
    });

    const data = {
      'customerName': this.companySummaryInformation.companyName,
      'customerCode': this.companySummaryInformation.companyName,
      'customerTeam': 1,
      'customerMailingAddress': this.companySummaryInformation.address,
      'customerMailingCity': this.companySummaryInformation.city,
      'customerMailingState': this.companySummaryInformation.stateTypeId,
      'customerMailingZip': this.companySummaryInformation.zip,
      'primaryContactName': this.companySummaryInformation.firstname + ' ' + this.companySummaryInformation.lastname,
      'primaryCellPhone': this.companySummaryInformation.cellPhone,
      'primaryContactPhone': this.companySummaryInformation.officePhone,
      'primaryContactEmail': this.companySummaryInformation.email,
      'primaryBillingEmail': this.companySummaryInformation.billingEmail,
      'primaryContactFax': '',
      'inRates': 0,
      'inPercentage': 0,
    };

    this.http.post(this.baseUrlAxlePoint + 'api/alxepoint/customer/profile', data, { headers: headers }).subscribe((response: any) => {
      this.customResponse = response;
      if (response.body[0].CustomerKey) {
        const mappingObject = {
          'customerUserInformationId': this.companySummaryInformation.customerParentInformationID,
          'legacyCustomerKeyId': response.body[0].CustomerKey,
          'fleetCustomerId': response.body[0].FleetCustomerId,
          'subCustomerId': response.body[0].SubCustomerKey,
        };

        const legacyMappingReq = this.http.post(this.rootURL + 'api/customers/user/legacyMapping', mappingObject);
        const defaultProtocolReq = this.profileService.getDefaultsProtocolsBeta(response.body[0].CustomerKey);

        forkJoin([legacyMappingReq, defaultProtocolReq]).subscribe(() => {
          const localPassword = localStorage.getItem('localPassword');
          this.redirectUser(this.companySummaryInformation.email, localPassword, response.body[0].SubCustomerKey);
        }, (error) => {
          console.error('CompleteSignUpService_completeSignUp', error);
        });
      }
    }, (error) => {
      console.error('CompleteSignUpService_completeSignUp', error);
    });


  }

  redirectUser(uname, pwd, subCustomerId) {
    this.loginService.userAuthentication(uname, pwd).subscribe((response: any) => {
      MessageemitterService.get('loginStatus').emit(['true']);
      this.localStorageService.setAuthorizationData(response);
      sessionStorage.setItem('currentUserEmail', uname);
      sessionStorage.setItem('emailInLocalStorage', uname);
    },
      (err: HttpErrorResponse) => {
        this.router.navigate(['/signup-complete']);
        console.error('CompleteSignUpService_redirectUser', err);
        return;
      }, () => {
        this.userInformationService.getUserInformationByEmail(sessionStorage.getItem('currentUserEmail')).subscribe((res) => {
          const userDetails = {
            'firstname': res.firstname,
            'middlename': res.middlename,
            'lastname': res.lastname,
            'email': res.email,
            'billingEmail': res.billingEmail,
            'phone': res.phone,
            'breakDownPhone': res.officePhone,
            'address': res.address,
            'city': res.city,
            'state': res.stateTypeId,
            'zip': res.zip,
            'isDemoComplete': res.isDemoComplete,
            'subScriptionType': res.subScriptionType,
            'viewProviderInvoice': res.viewProviderInvoice,
          };

          sessionStorage.setItem('userDetails', JSON.stringify(userDetails));
          sessionStorage.setItem('companyName', res.companyName);
          sessionStorage.setItem('customerTimezone', res.timeZoneTypeId === 0 ? 'America/New_York' : res.timeZoneTypeId);

          this.customResponse = res;
        }, (err) => {
          console.error('CompleteSignUpService_redirectUser', err);
        },
          () => {
            sessionStorage.setItem('customerUserInformationId', this.customResponse.customerUserInformationId);
            sessionStorage.setItem('legacyCustomerKeyId', this.customResponse.legacyCustomerKeyId);
            sessionStorage.setItem('fleetCustomerId', this.customResponse.fleetCustomerId);
            sessionStorage.setItem('customerParentInformationID', this.customResponse.customerParentInformationID);
            sessionStorage.setItem('userAssociation', this.customResponse.userAssociation);
            sessionStorage.setItem('subCustomerId', subCustomerId);
            sessionStorage.setItem('fleetCustomerId', this.customResponse.fleetCustomerId);
            sessionStorage.setItem('image', this.customResponse.image);
            sessionStorage.setItem('subCustomerId', this.customResponse.legacySubCustomerKey);
            sessionStorage.setItem('doNotShowTour', this.customResponse.doNotShowTour);
            sessionStorage.setItem('approvalAvailabilityStart', this.customResponse.approvalAvailabilityStart);
            sessionStorage.setItem('approvalAvailabilityStop', this.customResponse.approvalAvailabilityStop);
            sessionStorage.setItem('approvalLimitRepairsTow', this.customResponse.approvalLimitRepairsTow);
            sessionStorage.setItem('approvalLimitTire', this.customResponse.approvalLimitTire);
            sessionStorage.setItem('assignedTo', this.customResponse.assignedTo);
            sessionStorage.setItem('available24Hours', this.customResponse.available24Hours);
            sessionStorage.setItem('notAnApprover', this.customResponse.notAnApprover);
            sessionStorage.setItem('weekDay', this.customResponse.weekDay);
            sessionStorage.setItem('title', this.customResponse.title);
            sessionStorage.setItem('hierachy', this.customResponse.hierachy);
            sessionStorage.setItem('view', this.customResponse.view);
            sessionStorage.setItem('role', this.customResponse.role);
            sessionStorage.setItem('loggedInRegionName', this.customResponse.regionName);
            sessionStorage.setItem('loggedInDivisionName', this.customResponse.divisionName);
            sessionStorage.setItem('loggedInLocationName', this.customResponse.locationName);

            sessionStorage.setItem('ersSubcustomerId', this.customResponse.ersSubcustomerId);
            sessionStorage.setItem('ersDivisionId', this.customResponse.ersDivisionId);
            sessionStorage.setItem('ersLocationId', this.customResponse.ersLocationId);
            sessionStorage.setItem('fleetSubcustomerId', this.customResponse.fleetSubcustomerId);
            sessionStorage.setItem('fleetDivisionId', this.customResponse.fleetDivisionId);
            sessionStorage.setItem('fleetLocationId', this.customResponse.fleetLocationId);
            sessionStorage.setItem('agreementURL', this.customResponse.agreementTemplateURL);
            sessionStorage.setItem('subscriptionType', this.customResponse.subScriptionType);
            sessionStorage.setItem('restrictWOsDate', this.customResponse.restrictWOsDate ? this.customResponse.restrictWOsDate : '');
            sessionStorage.setItem('isAgreementAccepted', this.customResponse.isAgreementAccepted);
            this.pageLoader.next(false);
            this.router.navigate(['/pages']);
          });
      });
  }

  setPageLoader() {
    this.pageLoader.next(true);
  }
}
